import React from 'react';
import PropTypes from 'prop-types';
import LayoutBar from '../LayoutBar';

const LayoutHeader = ({
  children,
  type,
  className,
  ...rest
}) => (
  <LayoutBar
    position="top"
    tag="header"
    type={type}
    className={className}
    {...rest}
  >
    {children}
  </LayoutBar>
);

LayoutHeader.propTypes = {
  type: PropTypes.oneOf(['static', 'fixed', 'overlay', 'device-fixed']),
};

LayoutHeader.defaultProps = {
  type: 'static',
};

export default LayoutHeader;
